export default __webpack_public_path__ + "static/media/dubai-international-financial-center.f2873920.png";